// @generated by protoc-gen-es v2.14.1 with parameter "target=ts"
// @generated from file travplaces/v1/admin_role.proto (package travplaces.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_travplaces_v1_audit } from "./audit_pb";
import { file_travplaces_v1_authz } from "./authz_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file travplaces/v1/admin_role.proto.
 */
export const file_travplaces_v1_admin_role: GenFile = /*@__PURE__*/
  fileDesc("Ch50cmF2cGxhY2VzL3YxL2FkbWluX3JvbGUucHJvdG8SDXRyYXZwbGFjZXMudjEicQoEUm9sZRIKCgJpZBgBIAEoCRIMCgRuYW1lGAIgASgJEhMKC2Rlc2NyaXB0aW9uGAMgASgJEhEKCWlzX3N5c3RlbRgEIAEoCBITCgtwZXJtaXNzaW9ucxgFIAMoCRISCgp1c2VyX2NvdW50GAYgASgFIlkKDlBlcm1pc3Npb25JbmZvEgwKBG5hbWUYASABKAkSFAoMZGlzcGxheV9uYW1lGAIgASgJEhMKC2Rlc2NyaXB0aW9uGAMgASgJEg4KBnBhcmVudBgEIAEoCSISChBMaXN0Um9sZXNSZXF1ZXN0IjcKEUxpc3RSb2xlc1Jlc3BvbnNlEiIKBXJvbGVzGAEgAygLMhMudHJhdnBsYWNlcy52MS5Sb2xlIhgKFkxpc3RQZXJtaXNzaW9uc1JlcXVlc3QiTQoXTGlzdFBlcm1pc3Npb25zUmVzcG9uc2USMgoLcGVybWlzc2lvbnMYASADKAsyHS50cmF2cGxhY2VzLnYxLlBlcm1pc3Npb25JbmZvIksKEUNyZWF0ZVJvbGVSZXF1ZXN0EgwKBG5hbWUYASABKAkSEwoLZGVzY3JpcHRpb24YAiABKAkSEwoLcGVybWlzc2lvbnMYAyADKAkiNwoSQ3JlYXRlUm9sZVJlc3BvbnNlEiEKBHJvbGUYASABKAsyEy50cmF2cGxhY2VzLnYxLlJvbGUiVwoRVXBkYXRlUm9sZVJlcXVlc3QSCgoCaWQYASABKAkSDAoEbmFtZRgCIAEoCRITCgtkZXNjcmlwdGlvbhgDIAEoCRITCgtwZXJtaXNzaW9ucxgEIAMoCSI3ChJVcGRhdGVSb2xlUmVzcG9uc2USIQoEcm9sZRgBIAEoCzITLnRyYXZwbGFjZXMudjEuUm9sZSIfChFEZWxldGVSb2xlUmVxdWVzdBIKCgJpZBgBIAEoCSIlChJEZWxldGVSb2xlUmVzcG9uc2USDwoHZGVsZXRlZBgBIAEoCDL+AwoQQWRtaW5Sb2xlU2VydmljZRJbCglMaXN0Um9sZXMSHy50cmF2cGxhY2VzLnYxLkxpc3RSb2xlc1JlcXVlc3QaIC50cmF2cGxhY2VzLnYxLkxpc3RSb2xlc1Jlc3BvbnNlIguK6jADCgEokOowARJtCg9MaXN0UGVybWlzc2lvbnMSJS50cmF2cGxhY2VzLnYxLkxpc3RQZXJtaXNzaW9uc1JlcXVlc3QaJi50cmF2cGxhY2VzLnYxLkxpc3RQZXJtaXNzaW9uc1Jlc3BvbnNlIguK6jADCgEokOowARJeCgpDcmVhdGVSb2xlEiAudHJhdnBsYWNlcy52MS5DcmVhdGVSb2xlUmVxdWVzdBohLnRyYXZwbGFjZXMudjEuQ3JlYXRlUm9sZVJlc3BvbnNlIguK6jADCgEokOowAhJeCgpVcGRhdGVSb2xlEiAudHJhdnBsYWNlcy52MS5VcGRhdGVSb2xlUmVxdWVzdBohLnRyYXZwbGFjZXMudjEuVXBkYXRlUm9sZVJlc3BvbnNlIguK6jADCgEokOowAhJeCgpEZWxldGVSb2xlEiAudHJhdnBsYWNlcy52MS5EZWxldGVSb2xlUmVxdWVzdBohLnRyYXZwbGFjZXMudjEuRGVsZXRlUm9sZVJlc3BvbnNlIguK6jADCgEokOowAkKpAQoRY29tLnRyYXZwbGFjZXMudjFCDkFkbWluUm9sZVByb3RvUAFaL3RyYXZwbGFjZXMvZ2VuL3Byb3RvL3RyYXZwbGFjZXMvdjE7dHJhdnBsYWNlc3YxogIDVFhYqgINVHJhdnBsYWNlcy5WMcoCDVRyYXZwbGFjZXNcVjHiAhlUcmF2cGxhY2VzXFYxXEdQQk1ldGFkYXRh6gIOVHJhdnBsYWNlczo6VjFiBnByb3RvMw", [file_travplaces_v1_audit, file_travplaces_v1_authz]);

/**
 * Role is a named set of permissions.
 *
 * @generated from message travplaces.v1.Role
 */
export type Role = Message<"travplaces.v1.Role"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * Seeded roles the application reasons about by name. They cannot be
   * renamed, re-permissioned or deleted: `admin` is the way back into a
   * deployment, and a UI that lets somebody strip its permissions is a UI that
   * lets them lock everyone out with no way to undo it short of SQL.
   *
   * @generated from field: bool is_system = 4;
   */
  isSystem: boolean;

  /**
   * Permission enum value names, e.g. "PERMISSION_CITY_WRITE".
   *
   * @generated from field: repeated string permissions = 5;
   */
  permissions: string[];

  /**
   * How many accounts hold this role, so the console can warn before an edit
   * and explain why a delete was refused.
   *
   * @generated from field: int32 user_count = 6;
   */
  userCount: number;
};

/**
 * Describes the message travplaces.v1.Role.
 * Use `create(RoleSchema)` to create a new message.
 */
export const RoleSchema: GenMessage<Role> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_admin_role, 0);

/**
 * PermissionInfo is one permission and how to describe it to an operator.
 *
 * @generated from message travplaces.v1.PermissionInfo
 */
export type PermissionInfo = Message<"travplaces.v1.PermissionInfo"> & {
  /**
   * The enum value name, which is what is stored and sent.
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string display_name = 2;
   */
  displayName: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * The permission that implies this one, empty at the root. The console
   * indents by it, so the hierarchy is visible rather than something an
   * operator has to already know.
   *
   * @generated from field: string parent = 4;
   */
  parent: string;
};

/**
 * Describes the message travplaces.v1.PermissionInfo.
 * Use `create(PermissionInfoSchema)` to create a new message.
 */
export const PermissionInfoSchema: GenMessage<PermissionInfo> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_admin_role, 1);

/**
 * @generated from message travplaces.v1.ListRolesRequest
 */
export type ListRolesRequest = Message<"travplaces.v1.ListRolesRequest"> & {
};

/**
 * Describes the message travplaces.v1.ListRolesRequest.
 * Use `create(ListRolesRequestSchema)` to create a new message.
 */
export const ListRolesRequestSchema: GenMessage<ListRolesRequest> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_admin_role, 2);

/**
 * @generated from message travplaces.v1.ListRolesResponse
 */
export type ListRolesResponse = Message<"travplaces.v1.ListRolesResponse"> & {
  /**
   * @generated from field: repeated travplaces.v1.Role roles = 1;
   */
  roles: Role[];
};

/**
 * Describes the message travplaces.v1.ListRolesResponse.
 * Use `create(ListRolesResponseSchema)` to create a new message.
 */
export const ListRolesResponseSchema: GenMessage<ListRolesResponse> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_admin_role, 3);

/**
 * @generated from message travplaces.v1.ListPermissionsRequest
 */
export type ListPermissionsRequest = Message<"travplaces.v1.ListPermissionsRequest"> & {
};

/**
 * Describes the message travplaces.v1.ListPermissionsRequest.
 * Use `create(ListPermissionsRequestSchema)` to create a new message.
 */
export const ListPermissionsRequestSchema: GenMessage<ListPermissionsRequest> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_admin_role, 4);

/**
 * @generated from message travplaces.v1.ListPermissionsResponse
 */
export type ListPermissionsResponse = Message<"travplaces.v1.ListPermissionsResponse"> & {
  /**
   * @generated from field: repeated travplaces.v1.PermissionInfo permissions = 1;
   */
  permissions: PermissionInfo[];
};

/**
 * Describes the message travplaces.v1.ListPermissionsResponse.
 * Use `create(ListPermissionsResponseSchema)` to create a new message.
 */
export const ListPermissionsResponseSchema: GenMessage<ListPermissionsResponse> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_admin_role, 5);

/**
 * @generated from message travplaces.v1.CreateRoleRequest
 */
export type CreateRoleRequest = Message<"travplaces.v1.CreateRoleRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string description = 2;
   */
  description: string;

  /**
   * @generated from field: repeated string permissions = 3;
   */
  permissions: string[];
};

/**
 * Describes the message travplaces.v1.CreateRoleRequest.
 * Use `create(CreateRoleRequestSchema)` to create a new message.
 */
export const CreateRoleRequestSchema: GenMessage<CreateRoleRequest> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_admin_role, 6);

/**
 * @generated from message travplaces.v1.CreateRoleResponse
 */
export type CreateRoleResponse = Message<"travplaces.v1.CreateRoleResponse"> & {
  /**
   * @generated from field: travplaces.v1.Role role = 1;
   */
  role?: Role | undefined;
};

/**
 * Describes the message travplaces.v1.CreateRoleResponse.
 * Use `create(CreateRoleResponseSchema)` to create a new message.
 */
export const CreateRoleResponseSchema: GenMessage<CreateRoleResponse> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_admin_role, 7);

/**
 * @generated from message travplaces.v1.UpdateRoleRequest
 */
export type UpdateRoleRequest = Message<"travplaces.v1.UpdateRoleRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: repeated string permissions = 4;
   */
  permissions: string[];
};

/**
 * Describes the message travplaces.v1.UpdateRoleRequest.
 * Use `create(UpdateRoleRequestSchema)` to create a new message.
 */
export const UpdateRoleRequestSchema: GenMessage<UpdateRoleRequest> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_admin_role, 8);

/**
 * @generated from message travplaces.v1.UpdateRoleResponse
 */
export type UpdateRoleResponse = Message<"travplaces.v1.UpdateRoleResponse"> & {
  /**
   * @generated from field: travplaces.v1.Role role = 1;
   */
  role?: Role | undefined;
};

/**
 * Describes the message travplaces.v1.UpdateRoleResponse.
 * Use `create(UpdateRoleResponseSchema)` to create a new message.
 */
export const UpdateRoleResponseSchema: GenMessage<UpdateRoleResponse> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_admin_role, 9);

/**
 * @generated from message travplaces.v1.DeleteRoleRequest
 */
export type DeleteRoleRequest = Message<"travplaces.v1.DeleteRoleRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message travplaces.v1.DeleteRoleRequest.
 * Use `create(DeleteRoleRequestSchema)` to create a new message.
 */
export const DeleteRoleRequestSchema: GenMessage<DeleteRoleRequest> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_admin_role, 10);

/**
 * @generated from message travplaces.v1.DeleteRoleResponse
 */
export type DeleteRoleResponse = Message<"travplaces.v1.DeleteRoleResponse"> & {
  /**
   * @generated from field: bool deleted = 1;
   */
  deleted: boolean;
};

/**
 * Describes the message travplaces.v1.DeleteRoleResponse.
 * Use `create(DeleteRoleResponseSchema)` to create a new message.
 */
export const DeleteRoleResponseSchema: GenMessage<DeleteRoleResponse> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_admin_role, 11);

/**
 * AdminRoleService manages roles and what each one may do.
 *
 * A role is a named set of permissions; an account holds one role. Editing a
 * role changes what every account holding it can do, which is why these
 * procedures are guarded by PERMISSION_ROLE_MANAGE — and why the seeded roles
 * are not editable at all. See the note on Role.is_system.
 *
 * @generated from service travplaces.v1.AdminRoleService
 */
export const AdminRoleService: GenService<{
  /**
   * ListRoles returns every role with the permissions granted to it.
   *
   * @generated from rpc travplaces.v1.AdminRoleService.ListRoles
   */
  listRoles: {
    methodKind: "unary";
    input: typeof ListRolesRequestSchema;
    output: typeof ListRolesResponseSchema;
  },
  /**
   * ListPermissions returns every permission the application defines, with the
   * labels to show beside each, so the console can render a picker without
   * hard-coding the list.
   *
   * @generated from rpc travplaces.v1.AdminRoleService.ListPermissions
   */
  listPermissions: {
    methodKind: "unary";
    input: typeof ListPermissionsRequestSchema;
    output: typeof ListPermissionsResponseSchema;
  },
  /**
   * CreateRole adds a role and grants it the given permissions.
   *
   * @generated from rpc travplaces.v1.AdminRoleService.CreateRole
   */
  createRole: {
    methodKind: "unary";
    input: typeof CreateRoleRequestSchema;
    output: typeof CreateRoleResponseSchema;
  },
  /**
   * UpdateRole renames a role and replaces the permissions granted to it.
   *
   * The permission set is replaced wholesale rather than patched: the console
   * edits it as a set of tick boxes, and sending the result of that edit is
   * both what the caller means and what makes the call idempotent.
   *
   * @generated from rpc travplaces.v1.AdminRoleService.UpdateRole
   */
  updateRole: {
    methodKind: "unary";
    input: typeof UpdateRoleRequestSchema;
    output: typeof UpdateRoleResponseSchema;
  },
  /**
   * DeleteRole removes a role. Refused while any account still holds it —
   * deleting it would leave those accounts with no role and no way in.
   *
   * @generated from rpc travplaces.v1.AdminRoleService.DeleteRole
   */
  deleteRole: {
    methodKind: "unary";
    input: typeof DeleteRoleRequestSchema;
    output: typeof DeleteRoleResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_travplaces_v1_admin_role, 0);

